import React from 'react';

// DEFAULT AIG
import { ReactComponent as CalendarIcon } from '../../assets/images/Calender_Icon.svg';
import { ReactComponent as Phone } from '../../assets/images/Call_Icon.svg';
import { ReactComponent as Headset } from '../../assets/images/Servicer_Icon.svg';
import { ReactComponent as Replacement } from '../../assets/images/claim-complete.svg';
import { ReactComponent as Denied } from '../../assets/images/claim-cancelled.svg';
import { ReactComponent as Customer } from '../../assets/images/Customer.svg';
import { ReactComponent as ClaimSaved } from '../../assets/images/claim-saved.svg';
import { ReactComponent as ChatEndIcon } from '../../assets/images/chat-complete.svg';
import { ReactComponent as EmailSentIcon } from '../../assets/images/email-sent.svg';
import { ReactComponent as SystemErrorIcon } from '../../assets/images/exclamation-circle.svg';
// HWA
import { ReactComponent as HWACalendarIcon } from '../../assets/images/Vendor/HWA/Calender_Icon.svg';
import { ReactComponent as HWAPhone } from '../../assets/images/Vendor/HWA/Call_Icon.svg';
import { ReactComponent as HWAHeadset } from '../../assets/images/Vendor/HWA/Servicer_Icon.svg';
import { ReactComponent as HWAReplacement } from '../../assets/images/Vendor/HWA/claim-complete.svg';
import { ReactComponent as HWADenied } from '../../assets/images/Vendor/HWA/claim-cancelled.svg';
import { ReactComponent as HWACustomer } from '../../assets/images/Vendor/HWA/Customer.svg';
import { ReactComponent as HWAClaimSaved } from '../../assets/images/Vendor/HWA/claim-saved.svg';
import { ReactComponent as HWAChatEndIcon } from '../../assets/images/Vendor/HWA/chat-complete.svg';
import { ReactComponent as HWASystemErrorIcon } from '../../assets/images/Vendor/HWA/exclamation-circle.svg';
// ET
import { ReactComponent as ETCalendarIcon } from '../../assets/images/Vendor/ET/Calender_Icon.svg';
import { ReactComponent as ETPhone } from '../../assets/images/Vendor/ET/Call_Icon.svg';
import { ReactComponent as ETHeadset } from '../../assets/images/Vendor/ET/Servicer_Icon.svg';
import { ReactComponent as ETReplacement } from '../../assets/images/Vendor/ET/claim-complete.svg';
import { ReactComponent as ETDenied } from '../../assets/images/Vendor/ET/claim-cancelled.svg';
import { ReactComponent as ETCustomer } from '../../assets/images/Vendor/ET/Customer.svg';
import { ReactComponent as ETClaimSaved } from '../../assets/images/Vendor/ET/claim-saved.svg';
import { ReactComponent as ETChatEndIcon } from '../../assets/images/Vendor/ET/chat-complete.svg';
import { ReactComponent as ETEmailSentIcon } from '../../assets/images/Vendor/ET/email-sent.svg';
import { ReactComponent as ETSystemErrorIcon } from '../../assets/images/Vendor/ET/exclamation-circle.svg';
// Southbridge
import { ReactComponent as SBCalendarIcon } from '../../assets/images/Vendor/SB/Calender_Icon.svg';
import { ReactComponent as SBPhone } from '../../assets/images/Vendor/SB/Call_Icon.svg';
import { ReactComponent as SBHeadset } from '../../assets/images/Vendor/SB/Servicer_Icon.svg';
import { ReactComponent as SBReplacement } from '../../assets/images/Vendor/SB/claim-complete.svg';
import { ReactComponent as SBDenied } from '../../assets/images/Vendor/SB/claim-cancelled.svg';
import { ReactComponent as SBCustomer } from '../../assets/images/Vendor/SB/Customer.svg';
import { ReactComponent as SBClaimSaved } from '../../assets/images/Vendor/SB/claim-saved.svg';
import { ReactComponent as SBChatEndIcon } from '../../assets/images/Vendor/SB/chat-complete.svg';
import { ReactComponent as SBEmailSentIcon } from '../../assets/images/Vendor/SB/email-sent.svg';
import { ReactComponent as SBSystemErrorIcon } from '../../assets/images/Vendor/SB/exclamation-circle.svg';
// Constellation
import { ReactComponent as ConstellationCalendarIcon } from '../../assets/images/Vendor/Constellation/Calender_Icon.svg';
import { ReactComponent as ConstellationPhone } from '../../assets/images/Vendor/Constellation/Call_Icon.svg';
import { ReactComponent as ConstellationHeadset } from '../../assets/images/Vendor/Constellation/Servicer_Icon.svg';
import { ReactComponent as ConstellationReplacement } from '../../assets/images/Vendor/Constellation/claim-complete.svg';
import { ReactComponent as ConstellationDenied } from '../../assets/images/Vendor/Constellation/claim-cancelled.svg';
import { ReactComponent as ConstellationCustomer } from '../../assets/images/Vendor/Constellation/Customer.svg';
import { ReactComponent as ConstellationClaimSaved } from '../../assets/images/Vendor/Constellation/claim-saved.svg';
import { ReactComponent as ConstellationChatEndIcon } from '../../assets/images/Vendor/Constellation/chat-complete.svg';
import { ReactComponent as ConstellationEmailSentIcon } from '../../assets/images/Vendor/Constellation/email-sent.svg';
import { ReactComponent as ConstellationSystemErrorIcon } from '../../assets/images/Vendor/Constellation/exclamation-circle.svg';
// Cutler
import { ReactComponent as CutlerSystemErrorIcon } from '../../assets/images/exclamation-circle_new.svg';
// Homekick
import { ReactComponent as HomekickCalendarIcon } from '../../assets/images/Vendor/Homekick/Calender_Icon.svg';
import { ReactComponent as HomekickPhone } from '../../assets/images/Vendor/Homekick/Call_Icon.svg';
import { ReactComponent as HomekickHeadset } from '../../assets/images/Vendor/Homekick/Servicer_Icon.svg';
import { ReactComponent as HomekickReplacement } from '../../assets/images/Vendor/Homekick/claim-complete.svg';
import { ReactComponent as HomekickDenied } from '../../assets/images/Vendor/Homekick/claim-cancelled.svg';
import { ReactComponent as HomekickCustomer } from '../../assets/images/Vendor/Homekick/Customer.svg';
import { ReactComponent as HomekickClaimSaved } from '../../assets/images/Vendor/Homekick/claim-saved.svg';
import { ReactComponent as HomekickChatEndIcon } from '../../assets/images/Vendor/Homekick/chat-complete.svg';
import { ReactComponent as HomekickEmailSentIcon } from '../../assets/images/Vendor/Homekick/email-sent.svg';
import { ReactComponent as HomekickSystemErrorIcon } from '../../assets/images/Vendor/Homekick/exclamation-circle.svg';
// Rate
import { ReactComponent as RateCalendarIcon } from '../../assets/images/Vendor/Rate/Calender_Icon.svg';
import { ReactComponent as RatePhone } from '../../assets/images/Vendor/Rate/Call_Icon.svg';
import { ReactComponent as RateHeadset } from '../../assets/images/Vendor/Rate/Servicer_Icon.svg';
import { ReactComponent as RateReplacement } from '../../assets/images/Vendor/Rate/claim-complete.svg';
import { ReactComponent as RateDenied } from '../../assets/images/Vendor/Rate/claim-cancelled.svg';
import { ReactComponent as RateCustomer } from '../../assets/images/Vendor/Rate/Customer.svg';
import { ReactComponent as RateClaimSaved } from '../../assets/images/Vendor/Rate/claim-saved.svg';
import { ReactComponent as RateChatEndIcon } from '../../assets/images/Vendor/Rate/chat-complete.svg';
import { ReactComponent as RateEmailSentIcon } from '../../assets/images/Vendor/Rate/email-sent.svg';
import { ReactComponent as RateSystemErrorIcon } from '../../assets/images/Vendor/Rate/exclamation-circle.svg';
// Flex
import { ReactComponent as FlexCalendarIcon } from '../../assets/images/Vendor/Flex/Calendar_Icon.svg';
import { ReactComponent as FlexPhone } from '../../assets/images/Vendor/Flex/Call_Icon.svg';
import { ReactComponent as FlexHeadset } from '../../assets/images/Vendor/Flex/Servicer_Icon.svg';
import { ReactComponent as FlexReplacement } from '../../assets/images/Vendor/Flex/claim-complete.svg';
import { ReactComponent as FlexDenied } from '../../assets/images/Vendor/Flex/claim-cancelled.svg';
import { ReactComponent as FlexCustomer } from '../../assets/images/Vendor/Flex/Customer.svg';
import { ReactComponent as FlexClaimSaved } from '../../assets/images/Vendor/Flex/claim-saved.svg';
import { ReactComponent as FlexChatEndIcon } from '../../assets/images/Vendor/Flex/chat-complete.svg';
import { ReactComponent as FlexEmailSentIcon } from '../../assets/images/Vendor/Flex/email-sent.svg';
import { ReactComponent as FlexSystemErrorIcon } from '../../assets/images/Vendor/Flex/exclamation-circle.svg';

import styles from './WhiteLabeling.module.css';

const BrandedIcon = ({ client, iconType }) => {
    const getIcon = () => {
        const clientLower = client?.toLowerCase();
        // REPEAT THIS "IF" FOR EACH NEW BRAND
        if (clientLower === 'hwa') {
            if (iconType.toLowerCase() === 'confirm1') return <HWACalendarIcon />;
            if (iconType.toLowerCase() === 'confirm2-3') return <HWAPhone />;
            if (iconType.toLowerCase() === 'confirm4') return <HWAHeadset />;
            if (iconType.toLowerCase() === 'denied') return <HWADenied />;
            if (iconType.toLowerCase() === 'replacement') return <HWAReplacement />;
            if (iconType.toLowerCase() === 'customer') return <HWACustomer />;
            if (iconType.toLowerCase() === 'confirmsavedclaim') return <HWAClaimSaved />;
            if (iconType.toLowerCase() === 'chatcomplete') return <HWAChatEndIcon />;
            if (iconType.toLowerCase() === 'system-error') return <HWASystemErrorIcon />;
        }
        if (clientLower === 'et') {
            if (iconType.toLowerCase() === 'confirm1') return <ETCalendarIcon />;
            if (iconType.toLowerCase() === 'confirm2-3') return <ETPhone />;
            if (iconType.toLowerCase() === 'confirm4') return <ETHeadset />;
            if (iconType.toLowerCase() === 'denied') return <ETDenied />;
            if (iconType.toLowerCase() === 'replacement') return <ETReplacement />;
            if (iconType.toLowerCase() === 'customer') return <ETCustomer />;
            if (iconType.toLowerCase() === 'confirmsavedclaim') return <ETClaimSaved />;
            if (iconType.toLowerCase() === 'chatcomplete') return <ETChatEndIcon />;
            if (iconType.toLowerCase() === 'emailsent') return <ETEmailSentIcon />;
            if (iconType.toLowerCase() === 'system-error') return <ETSystemErrorIcon />;
        }
        if (clientLower === 'southbridge') {
            if (iconType.toLowerCase() === 'confirm1') return <SBCalendarIcon />;
            if (iconType.toLowerCase() === 'confirm2-3') return <SBPhone />;
            if (iconType.toLowerCase() === 'confirm4') return <SBHeadset />;
            if (iconType.toLowerCase() === 'denied') return <SBDenied />;
            if (iconType.toLowerCase() === 'replacement') return <SBReplacement />;
            if (iconType.toLowerCase() === 'customer') return <SBCustomer />;
            if (iconType.toLowerCase() === 'confirmsavedclaim') return <SBClaimSaved />;
            if (iconType.toLowerCase() === 'chatcomplete') return <SBChatEndIcon />;
            if (iconType.toLowerCase() === 'emailsent') return <SBEmailSentIcon />;
            if (iconType.toLowerCase() === 'system-error') return <SBSystemErrorIcon />;
        }
        if (clientLower === 'cutler') {
            if (iconType.toLowerCase() === 'system-error') return <CutlerSystemErrorIcon />;
        }
        if (clientLower === 'constellation') {
            if (iconType.toLowerCase() === 'confirm1') return <ConstellationCalendarIcon />;
            if (iconType.toLowerCase() === 'confirm2-3') return <ConstellationPhone />;
            if (iconType.toLowerCase() === 'confirm4') return <ConstellationHeadset />;
            if (iconType.toLowerCase() === 'denied') return <ConstellationDenied />;
            if (iconType.toLowerCase() === 'replacement') return <ConstellationReplacement />;
            if (iconType.toLowerCase() === 'customer') return <ConstellationCustomer />;
            if (iconType.toLowerCase() === 'confirmsavedclaim') return <ConstellationClaimSaved />;
            if (iconType.toLowerCase() === 'chatcomplete') return <ConstellationChatEndIcon />;
            if (iconType.toLowerCase() === 'emailsent') return <ConstellationEmailSentIcon />;
            if (iconType.toLowerCase() === 'system-error') return <ConstellationSystemErrorIcon />;
        }
        if (clientLower === 'homekick') {
            if (iconType.toLowerCase() === 'confirm1') return <HomekickCalendarIcon />;
            if (iconType.toLowerCase() === 'confirm2-3') return <HomekickPhone />;
            if (iconType.toLowerCase() === 'confirm4') return <HomekickHeadset />;
            if (iconType.toLowerCase() === 'denied') return <HomekickDenied />;
            if (iconType.toLowerCase() === 'replacement') return <HomekickReplacement />;
            if (iconType.toLowerCase() === 'customer') return <HomekickCustomer />;
            if (iconType.toLowerCase() === 'confirmsavedclaim') return <HomekickClaimSaved />;
            if (iconType.toLowerCase() === 'chatcomplete') return <HomekickChatEndIcon />;
            if (iconType.toLowerCase() === 'emailsent') return <HomekickEmailSentIcon />;
            if (iconType.toLowerCase() === 'system-error') return <HomekickSystemErrorIcon />;
        }
        if (clientLower === 'rate') {
            if (iconType.toLowerCase() === 'confirm1') return <RateCalendarIcon />;
            if (iconType.toLowerCase() === 'confirm2-3') return <RatePhone />;
            if (iconType.toLowerCase() === 'confirm4') return <RateHeadset />;
            if (iconType.toLowerCase() === 'denied') return <RateDenied />;
            if (iconType.toLowerCase() === 'replacement') return <RateReplacement />;
            if (iconType.toLowerCase() === 'customer') return <RateCustomer />;
            if (iconType.toLowerCase() === 'confirmsavedclaim') return <RateClaimSaved />;
            if (iconType.toLowerCase() === 'chatcomplete') return <RateChatEndIcon />;
            if (iconType.toLowerCase() === 'emailsent') return <RateEmailSentIcon />;
            if (iconType.toLowerCase() === 'system-error') return <RateSystemErrorIcon />;
        }
        if (clientLower === 'flex') {
            if (iconType.toLowerCase() === 'confirm1') return <FlexCalendarIcon />;
            if (iconType.toLowerCase() === 'confirm2-3') return <FlexPhone />;
            if (iconType.toLowerCase() === 'confirm4') return <FlexHeadset />;
            if (iconType.toLowerCase() === 'denied') return <FlexDenied />;
            if (iconType.toLowerCase() === 'replacement') return <FlexReplacement />;
            if (iconType.toLowerCase() === 'customer') return <FlexCustomer />;
            if (iconType.toLowerCase() === 'confirmsavedclaim') return <FlexClaimSaved />;
            if (iconType.toLowerCase() === 'chatcomplete') return <FlexChatEndIcon />;
            if (iconType.toLowerCase() === 'emailsent') return <FlexEmailSentIcon />;
            if (iconType.toLowerCase() === 'system-error') return <FlexSystemErrorIcon />;
        }

        // FALLTHROUGH IF CLIENT NOT DEFINED OR NO MATCH FOUND
        if (iconType.toLowerCase() === 'confirm1') return <CalendarIcon />;
        if (iconType.toLowerCase() === 'confirm2-3') return <Phone />;
        if (iconType.toLowerCase() === 'confirm4') return <Headset />;
        if (iconType.toLowerCase() === 'denied') return <Denied />;
        if (iconType.toLowerCase() === 'replacement') return <Replacement />;
        if (iconType.toLowerCase() === 'customer') return <Customer />;
        if (iconType.toLowerCase() === 'confirmsavedclaim') return <ClaimSaved />;
        if (iconType.toLowerCase() === 'chatcomplete') return <ChatEndIcon />;
        if (iconType.toLowerCase() === 'emailsent') return <EmailSentIcon />;
        if (iconType.toLowerCase() === 'system-error') return <SystemErrorIcon />;

        // FALLTHROUGH IF NO MATCH ON CLIENT OR TYPE.
        return null;
    };

    return <div className={styles.variableIconWrapper}>{getIcon()}</div>;
};

export default BrandedIcon;
